module.exports = __webpack_public_path__ + "media/preview/expo@4x-f9f58458.png";